export const ENV = {
  RESUME_ANALYSER_BASE_PATH: process.env.REACT_APP_RESUME_ANALYSER_BASE_PATH as string,
}